import { render, staticRenderFns } from "./TopStatistic.vue?vue&type=template&id=1324b768&scoped=true&"
import script from "./TopStatistic.vue?vue&type=script&lang=js&"
export * from "./TopStatistic.vue?vue&type=script&lang=js&"
import style0 from "./TopStatistic.vue?vue&type=style&index=0&id=1324b768&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../.jenkins/workspace/DMSDashboardDeployLIVE/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1324b768",
  null
  
)

export default component.exports